import React, {FC} from 'react'
import {UseFormRegister, FieldErrors} from 'react-hook-form'

export type InputProps = {
  name: string
  textPlaceholder: string
  readonly?: boolean
  register: UseFormRegister<any>
  errors: FieldErrors
  maxLength?: number
  minLength?: number
  caracteresTel?: boolean // Prop para habilitar o deshabilitar la validación de caracteres
  disabled?: boolean | undefined
}

const InputNumberDecimal: FC<InputProps> = ({
  name,
  textPlaceholder,
  register,
  maxLength = 9999,
  minLength = 0,
  errors,
  readonly = false,
  disabled = false,
  caracteresTel = false,
  ...props
}) => {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // let regex = /^\d+([,.]?\d{0,2})?$/
    if (readonly) return
    if (!/^\d*\.?\d{0,2}$/.test(e.key) && e.keyCode !== 8) {
      e.preventDefault()
    }
  }

  return (
    <div className='sdx_form_input'>
      <input
        type='text'
        className='form-control sdx-centra-input-form'
        placeholder={textPlaceholder}
        maxLength={maxLength}
        onKeyPress={handleKeyPress}
        disabled={disabled}
        readOnly={readonly}
        {...register(name)}
        {...props}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputNumberDecimal
